/**
 * Kadmin Light Theme — Colors
 *
 * Clean, professional palette with warm neutrals.
 * Customizable via kadmin.config.js theme overrides.
 */

const colors = {
  mode: "light",

  background: {
    default: "#FAFAF9",
    sidenav: "#FFFFFF",
    paper: "#FFFFFF",
    subtle: "#F5F5F4",
    elevated: "#FFFFFF",
    glass: "rgba(255, 255, 255, 0.9)",
    glassBorder: "rgba(0, 0, 0, 0.05)",
    cardInner: "rgba(0, 0, 0, 0.02)",
  },

  text: {
    main: "#525252",
    focus: "#1C1917",
    secondary: "#78716C",
    disabled: "#A8A29E",
  },

  transparent: { main: "rgba(0, 0, 0, 0)" },
  white: { main: "#ffffff", focus: "#ffffff" },
  black: { light: "#292524", main: "#1C1917", focus: "#0C0A09" },

  primary: {
    light: "#5EEAD4",
    main: "#0D9488",
    focus: "#0F766E",
    dark: "#115E59",
  },

  secondary: {
    light: "#A8A29E",
    main: "#78716C",
    focus: "#57534E",
  },

  info: {
    light: "#7DD3FC",
    main: "#0EA5E9",
    focus: "#0284C7",
  },

  success: {
    light: "#86EFAC",
    main: "#22C55E",
    focus: "#16A34A",
  },

  warning: {
    light: "#FDE047",
    main: "#F59E0B",
    focus: "#D97706",
  },

  error: {
    light: "#FCA5A5",
    main: "#EF4444",
    focus: "#DC2626",
  },

  light: { main: "#F5F5F4", focus: "#E7E5E4" },
  dark: { main: "#292524", focus: "#1C1917" },

  grey: {
    100: "#F5F5F4",
    200: "#E7E5E4",
    300: "#D6D3D1",
    400: "#A8A29E",
    500: "#78716C",
    600: "#57534E",
    700: "#44403C",
    800: "#292524",
    900: "#1C1917",
  },

  gradients: {
    primary: { main: "#5EEAD4", state: "#0D9488" },
    secondary: { main: "#A8A29E", state: "#57534E" },
    info: { main: "#7DD3FC", state: "#0EA5E9" },
    success: { main: "#86EFAC", state: "#22C55E" },
    warning: { main: "#FDE047", state: "#F59E0B" },
    error: { main: "#FCA5A5", state: "#EF4444" },
    light: { main: "#F5F5F4", state: "#D6D3D1" },
    dark: { main: "#44403C", state: "#1C1917" },
  },

  socialMediaColors: {
    facebook: { main: "#1877F2", dark: "#166FE5" },
    twitter: { main: "#1DA1F2", dark: "#1A91DA" },
    github: { main: "#181717", dark: "#0D0D0D" },
  },

  badgeColors: {
    primary: { background: "#CCFBF1", text: "#115E59" },
    secondary: { background: "#E7E5E4", text: "#57534E" },
    info: { background: "#E0F2FE", text: "#0369A1" },
    success: { background: "#DCFCE7", text: "#15803D" },
    warning: { background: "#FEF3C7", text: "#B45309" },
    error: { background: "#FEE2E2", text: "#B91C1C" },
  },

  coloredShadows: {
    primary: "#0D9488",
    secondary: "#57534E",
    info: "#0EA5E9",
    success: "#22C55E",
    warning: "#F59E0B",
    error: "#EF4444",
    light: "#D6D3D1",
    dark: "#1C1917",
  },

  inputBorderColor: "#D6D3D1",
  inputBorderHoverColor: "rgba(0, 0, 0, 0.3)",
  divider: "#E7E5E4",
  tabs: { indicator: { boxShadow: "#D6D3D1" } },

  headerOverlay: {
    button: "rgba(255, 255, 255, 0.15)",
    buttonHover: "rgba(255, 255, 255, 0.25)",
    icon: "rgba(255, 255, 255, 0.1)",
    iconHover: "rgba(255, 255, 255, 0.2)",
    chip: "rgba(255, 255, 255, 0.2)",
  },
};

export default colors;
